export default "__VITE_ASSET__8x3QRbHI__"